import classNames from "classnames/bind";
import combineClassNames from "classnames";
import { MouseEventHandler } from "react";
import styles from "./Chip.module.css";

const cx = classNames.bind(styles);

export const Chip = ({
  children,
  onClick,
  className,
  active = false,
}: {
  children: React.ReactNode;
  onClick?: MouseEventHandler;
  className?: string;
  active?: boolean;
}) => (
  <button
    className={combineClassNames(className, cx("chip", { "chip--active": active }))}
    onClick={onClick}
  >
    {children}
    {active && <span className={cx("icon")}>×</span>}
  </button>
);
